/* eslint-disable max-len */
import {defineMessages} from 'react-intl';

export default defineMessages({
	title: {
		id: 'trackOrderForm.title',
		defaultMessage: 'Check an order',
	},
	description: {
		id: 'trackOrderForm.description',
		defaultMessage:
			'See your order even if you are not a registered user. Enter the order number and billing zip code',
	},
	mandatoryFields: {
		id: 'trackOrderForm.mandatoryFields',
		defaultMessage: 'Fields with an asterisk (*) must be filled in.',
	},
	orderNoPlaceholder: {
		id: 'trackOrderForm.orderNoPlaceholder',
		defaultMessage: 'Order number*',
	},
	zipPlaceholder: {
		id: 'trackOrderForm.zipPlaceholder',
		defaultMessage: 'Billing zip code*',
	},
	orderError: {
		id: 'trackOrderForm.orderError',
		defaultMessage: 'Order not found',
	},
	orderRequiredError: {
		id: 'trackOrderForm.orderRequiredError',
		defaultMessage: 'Order number is required',
	},
	zipRequiredError: {
		id: 'trackOrderForm.emailRequiredError',
		defaultMessage: 'Zip code is required',
	},
	submitButton: {
		id: 'trackOrderForm.submitButton',
		defaultMessage: 'Apply',
	},
});
